<template>
	<div class="pup" v-if="show" @click="close">
		<div class="pup_div" :style="divStyle" @click.stop>
			<i class="el-icon-circle-close" @click.stop="close"/>
			<component :is="name" @close="close" :type='type' :from='from' :arr="arr" @consumerEdit='consumerEdit'/>
		</div>
	</div>
</template>

<script>
	import archivesDetail from "../../views/customer/archivesList/detail.vue"
	import supplierDetail from "../../views/customer/supplierList/detail.vue"
	import followUprecords from "../../views/customer/followUprecords/index.vue"
	import productLibraryEdit from "../../views/sourceGoods/productLibrary/edit.vue"
	import goodCategoryEdit from "../../views/sourceGoods/goodCategory/edit.vue"
	import albumCollectCreate from "../../views/sourceGoods/albumCollectCreate/index.vue"
	import commissionPlanEdit from "../../views/business/commissionPlan/edit.vue"
	import paymentCategoryEdit from "../../views/business/paymentCategory/edit.vue"
	import supplierSetAccountDetail from "../../views/business/supplierSetAccount/detail.vue"
	import paymentReceiptEdit from "../../views/business/paymentReceipt/edit.vue"
	import invoiceApplyForEdit from "../../views/business/invoiceApplyFor/edit.vue"
	import organizationalStructureEdit from "../../views/coordination/organizationalStructure/edit.vue"
	import permissionRoleEdit from "../../views/coordination/permissionRole/edit.vue"
	import approvalTemplateEdit from "../../views/coordination/approvalTemplate/edit.vue"
	import ProcessSet from "../../views/coordination/approvalTemplate/ProcessSet.vue"
	import initiateApproval from "../../views/coordination/initiateApproval/index.vue"
	import shopMallMangeEdit from "../../views/shopMall/shopMallMange/edit.vue"
	import goodsAfterSalEdit from "../../views/shopMall/goodsAfterSale/edit.vue"
    import goodsAfterSalRefund from "../../views/shopMall/goodsAfterSale/refund.vue"
	import settlementDocListEdit from "../../views/supplier/settlementDocList/edit.vue"
    import settlementDocListModify from "../../views/supplier/settlementDocList/modify.vue"
	import saleCountDetail from "../../views/supplier/saleCount/detail.vue"
	import AddDocumentDetail from "../AddDocument/AddDocument.vue"

    import OrderSend from "../../views/shopMall/productOrders/send.vue"
    import OrderDetail from "../../views/shopMall/productOrders/detail.vue"

    import CouponDesign from "../../views/sourceGoods/couponDesign/index.vue"

	export default {
		components: {
			archivesDetail,//客户-档案-客户档案详情
			supplierDetail,//客户-供应商-供应商详情
			followUprecords,//客户-拜访-客户跟进录入
			productLibraryEdit,//货源-商品-商品库-编辑
			goodCategoryEdit,//货源-商品-商品分类-新增编辑
			albumCollectCreate,//货源-册集-创建册集
			commissionPlanEdit,//业务-财务-提成方案-新增编辑
			paymentCategoryEdit,//业务-财务-收支类目维护-新增编辑
			supplierSetAccountDetail,//业务-财务-供应商结算-结算详情
			paymentReceiptEdit,//业务-采集-收付款据-新增编辑
			invoiceApplyForEdit,//业务-采集-发票申请-新增编辑
			AddDocumentDetail,//业务-采集-添加单据
			organizationalStructureEdit,//协同-管理-组织架构-新增编辑
			permissionRoleEdit,//协同-管理-权限角色(角色列表)-新增编辑
			approvalTemplateEdit,//协同-管理-流程审批模板-新增编辑
			ProcessSet,//协同-管理-流程审批模板-流程设置
			initiateApproval,//协同-新申请-发起审批申请
			shopMallMangeEdit,//商城-新开-商城管理-新增编辑
			goodsAfterSalEdit,//商城-发货-商品售后-按钮操作(售后)
            goodsAfterSalRefund, //商城-发货-商品售后-按钮操作(退款)
			settlementDocListEdit,//供应商-财务-结算单列表-编辑
            settlementDocListModify,//供应商-财务-结算单列表-修改
			saleCountDetail,//供应商-财务-货品销售统计-明细详情
            OrderSend,  // 订单发货
            OrderDetail,  // 订单详情
            CouponDesign,  // 在线制卡
		},
		props:{
			name:{
				type:String
			},
			show:{
				type:Boolean
			},
			scale:{
				type:Number
			},
			type:{
				type:Number
			},
			from:{
				type:Number
			},
            arr:{
                type:Array
            },
            divStyle:{
                type:Array|String
            }
		},
		computed:{},
		methods:{
			close(index){
				this.$emit('close',index)
			},
			
			consumerEdit(consumer_id){
				this.$emit('consumerEdit',consumer_id)
			}
		}
	}
</script>

<style scoped>
	.pup{
		width: 100%;
		height: 100%;
		display: flex;
		position: absolute;
		overflow-y: scroll;
		left:0;
		top:0;
		z-index:999;
		background: rgba(0, 0, 0, 0.3);
		align-items: center;
		justify-content: center;
	}
	.pup_div{
		background: #fff;
		border-radius: 10px;
		width: 80%;
		height: 80%;
		position: relative;
	}
	.el-icon-circle-close{
		font-size: 28px;
		color: red;
		position: absolute;
		top: -10px;
		right: -10px;
		z-index: 9999;
		background-color: #fff;
		border-radius: 50%;
	}
</style>